import { render, staticRenderFns } from "./resourceComTabs.vue?vue&type=template&id=4d05785d&"
import script from "./resourceComTabs.vue?vue&type=script&lang=js&"
export * from "./resourceComTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports